'use client';

import type { FC } from 'react';
import { formatCreditsNumber } from '../utils/formatters';
import { useCountUp } from '../hooks/useCountUp';

interface BonusCreditsCountUpProps {
  amount: number;
}

export const BonusCreditsCountUp: FC<BonusCreditsCountUpProps> = ({ amount }) => {
  const displayed = useCountUp(amount);

  return <>{formatCreditsNumber(displayed)}</>;
};
